import React from 'react';
import Title from '../../title';
import Customer from '../../dropdown/customer';
import Loading from '../../loading';
import $ from "jquery";
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import Getstatement from './getstatement';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ReadCookie from '../../../functions/readcookies';
import { Grid, Dropdown, Input, Pagination, Button } from 'semantic-ui-react';
import Updates from './followuphistory';
import Checkbox from '@material-ui/core/Checkbox';

class Statement extends React.Component {

  state = {
    fullWidth: true, maxWidth: 'lg', statements: [], open: false, customerTypeOption: [], types: false, menuPermission: [],
    openUpdates: false, pageNumber: 0, totalPages: 10, boundaryRange: 1, siblingRange: 1, showEllipsis: true, avoidvalue: 10,
    showFirstAndLastNav: true, showPreviousAndNextNav: true, zero: true, duedatefilter: 'Date Wise', sort: 'desc', search: '',
  }

  componentDidMount() {
    
    this.menuControl();
  }

  getcustomerType() {
    let context = this;
    context.setState({ menucontrol: false });
    $.ajax({
      type: 'POST',
      url: Server() + 'menucontrol/getcustomertypes.php',
      success: function(data)
      {
        try {
          data = JSON.parse(data);
          var x = [];
          x.push({key: 'All', text: 'All', value: 'All'});
          data.map((y) => { x.push({key: y.type_name, text: y.type_name, value: y.id}); })
          context.setState({ customerTypeOption: x });
        } catch (e) {
        }
      },
      error: function(err) {
        alert('Try again!!!')
      }
    });
  }

  menuControl() {
    let menuPermission = Permission('customer-statement', this.props.menus);
    if (menuPermission.view) {
      this.getcustomerType();
      this.getToday();
    }
    this.setState({ menuPermission })
  }

  getToday() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10) { dd = '0' + dd; }
    if(mm < 10){ mm = '0' + mm; }
    today = yyyy+'-'+mm+'-'+dd;
    let firstDay = yyyy+'-'+mm+'-01';
    this.setState({ to_date: today, from_date: firstDay, openUpdates: false });
    this.get(today, firstDay, 1, this.state.search);
  }

  statementExport() {
    if (!this.state.menuPermission.exports) {
      alert('You Are Not Allow To Export!!!');
      return;
    }
    let cook = (ReadCookie("vaigai"));
    window.location = Server() + 'statement/export.php?eid='+cook.id+'&fromDate='+this.state.from_date+
    '&toDate='+this.state.to_date+'&avoidzero='+this.state.avoidvalue+'&search='+this.state.search;
  }

  searching() {
    this.get(this.state.to_date, this.state.from_date, 1, this.state.search);
  }

  getOpeningandClosingBalance(toDate, fromDate) {
    let context = this;
    let data = { toDate, fromDate };
    let closingBalance = 0;
    let openingBalance = 0;
    $.ajax({
      type: 'POST', data: data, url: Server() + 'statement/getopeningandclosingbalance.php',
      success: function(data) {
        console.log(data);
        try {
          data = JSON.parse(data);
          data.map((v) => { closingBalance = v.closing_balance; openingBalance = v.opening_balance; })
        } catch (e) {
          alert('Error to get opening and closing balance!!!');
        }
        context.setState({ closingBalance, openingBalance })
      },
      error: function(e) {
        alert('Try again!!')
      }
    });

  }

  get(to, firstDay, page, search) {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let fromDate = firstDay;
    let toDate = to;
    let data1 = { 'from': fromDate, 'to': toDate, 'executiveId': cook.id, 'page': page, 'avoidzero': this.state.avoidvalue, 'search': search };
    this.getOpeningandClosingBalance(to, firstDay)
   
    this.setState({ load: true, message: 'Getting Statement!!!', openUpdates: false, toDates: to, fromDates: firstDay });
    $.ajax({
      type: 'POST', data: data1, url: Server() + 'statement/get.php',
      success: function(data) {
        console.log(data);
        try {
          let totalPages = 0;
          let statements = [];
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            totalPages = data[i].totalPages;
            statements = data[i].data;
          }
          context.setState({ statements: statements, dumysatements: statements, totalPages, pageNumber: page, load: false })
          context.sortVariable('due_date');
        } catch (e) { context.setState({ load: false }); }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  handleChange = name => event => { this.setState({ [name]: event.target.value }); };

  handlePaginationChange = (e, { activePage }) => {
    this.get(this.state.to_date, this.state.from_date, activePage, this.state.search);
  }

  handleCloses() { this.setState({ open: false, openUpdates: false }) }

  onChange = (type) => (f, { value }) => {
    let data = this.state.dumysatements;
    let items = [];
    data.map((z) => {
      if (value == 'All') {
        items.push(z)
      }
      else {
        if (z.type == value) {
          items.push(z)
        }
      }
    });
    this.setState({ statements: items, types: true })
  }

  search = (type) => (f, { value }) => {
    this.setState({ [type]: value });
  }

  update(data) {
    this.setState({ statements: data, openUpdates: false });
    this.handleCloses();
  }

  sortInteger(val) {
    let array = this.state.statements;
    if (this.state.sort == 'asc') {
      array.sort(function(a,b){
        return a[val] - b[val];
        }
      );
      this.setState({ statements: array, sort: 'desc' })
    }
    else {
      array.sort(function(b,a){
        return a[val ]- b[val];
        }
      );
      this.setState({ statements: array, sort: 'asc' })
    }
  }

  sortVariable(val) {
    let data = this.state.statements;
    data.map((z) => {
      if (z.due_date == '' || z.due_date == null) {
        z.due_date = '0000-00-00';
      }
    })
    if (this.state.sort == 'desc') {
      data.sort(this.getSortOrderDesc(val));
      this.setState({ statements: data, sort: 'asc' })
    }
    else {
      data.sort(this.getSortOrderAsc(val));
      this.setState({ statements: data, sort: 'desc' })
    }
  }

  getSortOrderAsc(prop) {
    return function(a, b) {
      if (a[prop] > b[prop]) {
          return 1;
      } else if (a[prop] < b[prop]) {
          return -1;
      }
      return 0;
    }
  }

  getSortOrderDesc(prop) {
    return function(b, a) {
      if (a[prop] > b[prop]) {
          return 1;
      } else if (a[prop ] < b[prop]) {
          return -1;
      }
      return 0;
    }
  }

  dueDateFilter = (type) => (f, { value }) => { this.setState({ [type]: value }) }

  

  render() {
    let closingbalance = 0; let closebalance = 0; let i = 1;
    let getClosingBalance = this.state.closingBalance;
    let getOpeningBalance = this.state.openingBalance;
    let dueDateFilterOption = [
      { key: 'Today', text: 'Today', value: 'Today' },
      { key: 'Next 7 Days', text: 'Next 7 Days', value: 'Next 7 Days' },
      { key: 'Date Wise', text: 'Date Wise', value: 'Date Wise' },
    ];
    let { pageNumber } = this.state;
    pageNumber = (pageNumber - 1) * 100;
    return (
      <div>
        <Title title={'Customer Statement'} openDrawer={this.props.openDrawer}/>
        <Loading load={this.state.load} message={this.state.message} />
        { this.state.menuPermission.view ?
          (
            <div>
              <div style={{display: this.state.statementview}}>
                <div style={{display: 'flex'}}>
                  <div style={{marginLeft: 5}}>
                    <b>From Date</b><br/>
                    <input type="date"  id="date" value={this.state.from_date}
                      style={{height: 35 }} onChange={this.handleChange('from_date')} />
                  </div>
                  <div style={{marginLeft: 5}}>
                    <b>To Date</b><br/>
                    <input type="date" id="date" value={this.state.to_date}
                      style={{height: 35 }} onChange={this.handleChange('to_date')} />
                  </div>
                  <div style={{marginLeft: 5}}>
                    DueDate Filter<br/>
                    <Dropdown fluid onChange={this.dueDateFilter('duedatefilter')}
                      selection options={dueDateFilterOption} value={this.state.duedatefilter}  />
                  </div>
                  <div style={{marginLeft: 5}}>
                    <br/>
                    <Dropdown id="Type" onChange={this.onChange('type')} placeholder="Customer Type"
                      search selection options={this.state.customerTypeOption}
                      value={this.props.type} style={{ borderColor: '#5A9CBB' }} />
                  </div>
                  <div style={{marginLeft: 5}}>
                    <br/>
                    <Input style={{width: 250}} focus onChange={this.search('search')} placeholder="Search" />
                  </div>
                  <div style={{marginLeft: 5}}>
                    <br/>
                    <Input style={{width: 100}} value={this.state.avoidvalue} focus onChange={this.search('avoidvalue')} placeholder="Starting Value" />
                  </div>
                  <div style={{marginLeft: 5}}>
                    <br/><Button primary onClick={this.searching.bind(this)}>Search</Button>
                  </div>
                  <div style={{marginLeft: 5}}>
                    <br/><Button primary onClick={this.statementExport.bind(this, 'table')}>Export</Button>
                  </div>
                </div>

              <div style={{padding: '0.5%'}}>
                <Grid style={{color: '#709930', fontSize: 15, fontWeight: 'bold'}}>
                  <Grid.Column mobile={16} tablet={16} computer={8}>{"Opening Balance : "+Number(getOpeningBalance * -1).toFixed(2)}</Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8} style={{float: 'right'}}><div align='right'>{"Closing Balance : "+Number(getClosingBalance * -1).toFixed(2)}</div></Grid.Column>
                </Grid>
                <div id='scrolls'>
                  <table id="table" width='100%'>
                    <tr>
                      <th id="th"><center>Si</center></th>
                      <th id="th" onClick={this.sortVariable.bind(this, 'name')}><center>Name</center></th>
                      <th id="th" onClick={this.sortVariable.bind(this, 'taluk')}><center>Taluk</center></th>
                      <th id="th" onClick={this.sortInteger.bind(this, 'openingbalance')}><center>Opening Balance</center></th>
                      <th id="th" onClick={this.sortInteger.bind(this, 'closingbalance')}><center>Closing Balance</center></th>
                      <th id="th" onClick={this.sortVariable.bind(this, 'due_date')}><center>Due Date</center></th>
                      <th id="th" onClick={this.sortVariable.bind(this, 'follower_name')}><center>Follow-by</center></th>
                      <th id="th"><center>View</center></th>
                    </tr>
                    { this.state.statements.map((z)=> {
                        let finalOpeningBalance = z.openingbalance; let finalClosingBalance = z.closingbalance;
                        let substring; let substring1;
                        try {
                          finalOpeningBalance = Number(finalOpeningBalance * -1).toFixed(2);
                        } catch (e) {
                          finalOpeningBalance = 0;
                        }
                        try {
                          finalClosingBalance = Number(finalClosingBalance * -1).toFixed(2);
                        } catch (e) {
                          finalClosingBalance = 0;
                        }

                          closebalance = z.closingbalance;
                          closebalance = Number(closebalance);
                          if (closebalance > 0) {
                              closingbalance = closingbalance + closebalance;
                          }
                          else {
                            closingbalance = closingbalance + closebalance;
                          }

                          if (this.state.duedatefilter == 'Date Wise') {
                            return(
                              <tr id='rowselected'>
                                <td><center>{(pageNumber + i++)}</center></td>
                                <td>{z.id+"->"+z.name}</td>
                                <td>{z.taluk}</td>
                                <td><div style={{textAlign: 'right'}}>{finalOpeningBalance}</div></td>
                                <td><div style={{textAlign: 'right'}}>{finalClosingBalance}</div></td>
                                <td id="pointer"
                                onClick={ () =>
                                  {
                                    if (!this.state.menuPermission.edit) {
                                      alert('You Are Not Allow To Edit!!!');
                                      return;
                                    }
                                    this.setState({ openUpdates: true,
                                      statementId: z.statement_id,
                                      customerId: z.id
                                    })
                                  }}><center>{z.due_date}</center>
                                </td>
                                <td id="pointer" style={{fontSize: 12}}
                                onClick={ () =>
                                  {
                                    if (!this.state.menuPermission.edit) {
                                      alert('You Are Not Allow To Edit!!!');
                                      return;
                                    }
                                    this.setState({ openUpdates: true,
                                      statementId: z.statement_id,
                                      customerId: z.id })
                                    }}>{z.follower_name}
                                </td>
                                <td id="pointer"
                                onClick={ () =>
                                  {
                                    this.setState({ sendClosingBalance: finalClosingBalance, sendOpeneingBalance: finalOpeningBalance, selectedCustomer: z.id,
                                      selectedCustomerName: z.name,
                                      open: true,
                                      getClosingbalance: z.closingbalance
                                    })
                                  }}><center>{'view'}</center>
                                </td>
                              </tr>
                            )
                          }
                          else if (this.state.duedatefilter == 'Today') {
                            if (this.state.to_date == z.due_date) {
                              return(
                                <tr id='rowselected'>
                                  <td><center>{(pageNumber + i++)}</center></td>
                                  <td>{z.id+"->"+z.name}</td>
                                  <td>{z.taluk}</td>
                                  <td><div style={{textAlign: 'right'}}>{finalOpeningBalance}</div></td>
                                  <td><div style={{textAlign: 'right'}}>{finalClosingBalance}</div></td>
                                  <td id="pointer"
                                    onClick={ () => {
                                      if (!this.state.menuPermission.edit) {
                                        alert('You Are Not Allow To Edit!!!');
                                        return;
                                      } 
                                      this.setState({ openUpdates: true, statementId: z.statement_id, customerId: z.id }) 
                                    }}>
                                    <center>{z.due_date}</center>
                                  </td>
                                  <td id="pointer" style={{fontSize: 12}}
                                    onClick={ () => { 
                                      if (!this.state.menuPermission.edit) {
                                        alert('You Are Not Allow To Edit!!!');
                                        return;
                                      }
                                      this.setState({ openUpdates: true, statementId: z.statement_id, customerId: z.id }) 
                                    }}>
                                    {z.follower_name}
                                  </td>
                                  <td id="pointer"
                                  onClick={ () =>
                                    { this.setState({ sendClosingBalance: finalClosingBalance, sendOpeneingBalance: finalOpeningBalance, selectedCustomer: z.id, selectedCustomerName: z.name, open: true, getClosingbalance: z.closingbalance })
                                    }}><center>{'view'}</center>
                                  </td>
                                </tr>
                              )
                            }
                          }
                          else {
                            var someDate = new Date(this.state.to_date);
                            someDate.setDate(someDate.getDate() + 7); //number  of days to add, e.x. 15 days
                            var dateFormated = someDate.toISOString().substr(0,10);
                            if (z.due_date <= dateFormated && z.due_date >= this.state.to_date) {
                              return(
                                <tr id='rowselected'>
                                  <td><center>{(pageNumber + i++)}</center></td>
                                  <td>{z.id+"->"+z.name}</td>
                                  <td>{z.taluk}</td>
                                  <td><div style={{textAlign: 'right'}}>{finalOpeningBalance}</div></td>
                                  <td><div style={{textAlign: 'right'}}>{finalClosingBalance}</div></td>
                                  <td id="pointer" onClick={ () => 
                                    { 
                                      if (!this.state.menuPermission.edit) {
                                        alert('You Are Not Allow To Edit!!!');
                                        return;
                                      }
                                      this.setState({ openUpdates: true, statementId: z.statement_id, customerId: z.id }) 
                                    }}>
                                    <center>{z.due_date}</center>
                                  </td>
                                  <td id="pointer" style={{fontSize: 12}}
                                    onClick={ () => { 
                                      if (!this.state.menuPermission.edit) {
                                        alert('You Are Not Allow To Edit!!!');
                                        return;
                                      }
                                      this.setState({ openUpdates: true, statementId: z.statement_id, customerId: z.id }) 
                                    }}>
                                    {z.follower_name}
                                  </td>
                                  <td id="pointer"
                                      onClick={ () => {
                                        this.setState({ sendClosingBalance: finalClosingBalance, sendOpeneingBalance: finalOpeningBalance, selectedCustomer: z.id, selectedCustomerName: z.name, open: true, getClosingbalance: z.closingbalance }) }}>
                                      <center>{'view'}</center>
                                  </td>
                                </tr>
                              )
                            }
                          }
                      })
                    }
                  </table>
                </div>
                <div align="right">
                  <Pagination activePage={this.state.pageNumber} boundaryRange={this.state.boundaryRange} onPageChange={this.handlePaginationChange}
                    siblingRange={this.state.siblingRange} totalPages={this.state.totalPages} ellipsisItem={this.state.showEllipsis ? undefined : null}
                    prevItem={this.state.showPreviousAndNextNav ? undefined : null} nextItem={this.state.showPreviousAndNextNav ? undefined : null} />
                </div>
              </div>

              <React.Fragment>
                <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}  open={this.state.open}
                  onClose={this.handleCloses.bind(this)} aria-labelledby="max-width-dialog-title">
                  <DialogTitle id="max-width-dialog-title">Detailed Statement</DialogTitle>
                  <DialogContent>
                    <Getstatement fromDate={this.state.from_date} toDate={this.state.to_date} menuPermission={this.state.menuPermission} sendClosingBalance={this.state.sendClosingBalance} sendOpeneingBalance = {this.state.sendOpeneingBalance}  customername={this.state.selectedCustomerName} id={this.state.selectedCustomer} getClosingbalance={Number(this.state.getClosingbalance * -1)}  />
                  </DialogContent>
                </Dialog>
              </React.Fragment>

              <Updates openUpdates={this.state.openUpdates} data={this.state.statements} customerId={this.state.customerId} statementId={this.state.statementId}
                getToday={this.getToday.bind(this)} update={this.update.bind(this)} handleCloses={this.handleCloses.bind(this)} />
              </div>
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Statement;
